
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: 'SignUpReportCustomerModal',
  emits: ["close"],
  methods: {
    ...mapActions(['toggleSignUpReportCustomerModal']),
    closeModal() {
      document.body.classList.remove("is-popup-opened");
      document.body.classList.add("is-popup-closed");
      setTimeout(() => {
        this.toggleSignUpReportCustomerModal();
        document.body.classList.remove("is-popup-closed");
      }, 250);
    },
  },
  computed: {
    ...mapGetters(['showSignUpReportCustomerModal']),
  },
});
